module.exports = __webpack_public_path__ + "img/32.f8a444f2.jpg";